package diana.soleil.design.iraniancanadienbazzar.core.common

/** Web push is not wired (no service worker); nothing to ask. */
actual fun requestPushPermission() = Unit
